import { TextEncoder, TextDecoder } from 'text-encoding-shim';

// Ensure they are available globally
global.TextEncoder = TextEncoder;
global.TextDecoder = TextDecoder;